import clsx from 'clsx'
import React, { useEffect, useRef, useState } from 'react'
import cls from './Casino.module.css'
import GIFT from '../../assets/images/gift.svg'
import COPY from '../../assets/images/copy.svg'
import { useResize } from '../../hooks/useResize'
import ym from 'react-yandex-metrika'
const REWARDS = [
    {
        id: 'reward1',
        value: 'кэшбек 10%',
        code: 'CASH10',
    },
    {
        id: 'reward2',
        value: 'кэшбек 20%',
        code: 'CASH20',
    },
    {
        id: 'reward3',
        value: 'кэшбек 15%',
        code: 'CASH15',
    },
    {
        id: 'reward4',
        value: 'кэшбек 20%',
        code: 'CASH20',
    },
    {
        id: 'reward5',
        value: 'кэшбек 10%',
        code: 'CASH10',
    },
    {
        id: 'reward6',
        value: 'кэшбек 20%',
        code: 'CASH20',
    },
    {
        id: 'reward7',
        value: 'кэшбек 10%',
        code: 'CASH10',
    },
    {
        id: 'reward8',
        value: 'кэшбек 15%',
        code: 'CASH15',
    },
    {
        id: 'reward9',
        value: 'кэшбек 15%',
        code: 'CASH15',
    },
]
let isTimeoutEnd = false
// const REWARDS = Array.from({ length: 360 }).map((_, i) => ({ id: i, value: i }))
const WHEEL_SECTORS = 360 / REWARDS.length
const WHEEL_OFFSET = Math.floor(180 / REWARDS.length)
const COLORS = ['#d3b8d8', '#cc887c', '#ecc2c5']
export const Casino = ({ isMinicart = false }) => {
    const { width } = useResize()

    const [isOpen, setOpen] = useState(false)
    const [isOpenCondition, setOpenCondition] = useState(false)
    const correctionRotate = width > 767 ? 180 : 270

    const [reward, setReward] = useState<(typeof REWARDS)[0] | null>(
        localStorage.getItem('reward') ? JSON.parse(localStorage.getItem('reward') as string) : null
    )
    const casinoRef = useRef<HTMLDivElement>(null)
    const wheelRef = useRef<HTMLUListElement>(null)
    const spinBtn = useRef<HTMLButtonElement>(null)

    const [isSaved, setSaved] = useState(false)

    const saveToBuffer = (code: string) => {
        navigator.clipboard
            .writeText(code)
            .then(() => setSaved(true))
            .finally(() => {
                ym('reachGoal', 'COPY_PROMOCODE')
                setTimeout(() => {
                    setSaved(false)
                }, 1000)
            })
    }
    const selectPrice = (rotation: number) => {
        const idx = Math.floor(rotation / WHEEL_SECTORS)
        // const idx = Math.floor((360 - rotation) / WHEEL_SECTORS)
        console.log(rotation, 360 - rotation, idx, REWARDS[idx])
        setReward(REWARDS[idx])
        localStorage.setItem('reward', JSON.stringify(REWARDS[idx]))
    }
    const rotateEnd = () => {
        if (wheelRef.current) {
            console.log('cas')
            const rotate = Number(wheelRef.current.style.getPropertyValue('--rotate'))
            const rotation = rotate % 360
            wheelRef.current.style.setProperty('--rotate', rotation.toString())
            wheelRef.current.style.setProperty('--duration', '0s')
            console.log(correctionRotate)
            selectPrice((rotation + correctionRotate) % 360)
        }
        if (spinBtn.current) spinBtn.current.disabled = false
    }
    useEffect(() => {
        const timeout = setTimeout(() => {
            if (!isTimeoutEnd && !reward) setOpen(true)
            isTimeoutEnd = true
        }, 10000)
        const rt = localStorage.getItem('wheel_rotation')
        if (wheelRef.current) {
            if (rt) {
                console.log(rt, 'ret')
                wheelRef.current.setAttribute('style', `--rotate: ${rt.toString()}`)
            }
            wheelRef.current.setAttribute(
                'style',
                `background: conic-gradient(from -90deg,
                    ${REWARDS.map((r, i) => {
                        let idx = 0
                        if (REWARDS.length % 2 === 0) idx = 2
                        else idx = 3
                        return `${COLORS[i % idx]} 0 ${
                            (100 / REWARDS.length) * (REWARDS.length - i)
                        }%`
                    }).reverse()}
                );
                --rotate: ${rt ? rt.toString() : 0}`
            )
            wheelRef.current.addEventListener('transitionend', rotateEnd)
        }
        return () => {
            clearTimeout(timeout)
            wheelRef?.current?.removeEventListener('transitionend', rotateEnd)
        }
    }, [])

    const randomBetween = (min: number, max: number) => {
        min = Math.ceil(min)
        max = Math.floor(max)
        return Math.floor(Math.random() * (max - min + 1)) + min
    }
    const spinWheel = () => {
        setReward(null)
        if (spinBtn.current) spinBtn.current.disabled = true
        const duration = randomBetween(5, 10)
        const rotation = Math.floor(Math.random() * 360 + randomBetween(2000, 6000))
        localStorage.setItem('wheel_rotation', rotation.toString())
        if (wheelRef.current) {
            wheelRef.current.style.setProperty('--duration', `${duration}s`)
            wheelRef.current.style.setProperty('--rotate', rotation.toString())
        }
        ym('reachGoal', 'WHEEL_OF_FORTUNE')
    }
    return (
        <>
            <div ref={casinoRef} className={clsx(cls.dialog, isOpen && cls.dialogOpen)}>
                <div className={cls.casino}>
                    <div className={cls.casino_close} onClick={() => setOpen(false)}>
                        &times;
                    </div>
                    <div className={cls.wheelWrapper}>
                        <ul ref={wheelRef} className={cls.wheel}>
                            {REWARDS.map((_reward, i) => (
                                <li
                                    className={cls.reward}
                                    key={_reward.id}
                                    style={
                                        {
                                            '--rotate': `${WHEEL_SECTORS * -i - WHEEL_OFFSET}deg`,
                                        } as React.CSSProperties
                                    }>
                                    {reward?.id === _reward.id ? (
                                        <span>{_reward.value}</span>
                                    ) : (
                                        <span></span>
                                    )}
                                </li>
                            ))}
                        </ul>
                        <div className={cls.pinCircle}>
                            <div className={cls.pin}></div>
                        </div>
                    </div>

                    <div className={cls.casinoInfo}>
                        {reward ? (
                            <>
                                <h2>ПОЗДРАВЛЯЕМ!</h2>
                                <div className={cls.your_reward}>
                                    <span>
                                        Оформляй заказ, вводи промокод и получай {reward.value}
                                    </span>

                                    <span
                                        className={isSaved && cls.Saved}
                                        onClick={() => saveToBuffer(reward.code)}>
                                        Промокод: {reward.code} <img src={COPY} />
                                    </span>

                                    <small>*промокод активен до 19.05.2025 на любую покупку</small>
                                </div>
                            </>
                        ) : (
                            <>
                                <h2>Испытай удачу и лови свой кэшбек!</h2>
                                <span>Крутите колесо и получайте гарантированнные подарки!</span>
                                <button ref={spinBtn} onClick={spinWheel}>
                                    Крутить колесо
                                </button>
                            </>
                        )}
                        <div
                            className={cls.condition}
                            onClick={() => setOpenCondition((prev) => !prev)}>
                            Условия использования
                        </div>
                        {isOpenCondition && (
                            <span className={cls.condition_info}>
                                Бонусы начисленные во время акции действую до 30.06.2025
                            </span>
                        )}
                    </div>
                </div>
            </div>
            <div className={cls.dialog_backdrop}></div>
            <button
                className={clsx(cls.openCasino, isMinicart && cls.hasCart)}
                onClick={() => setOpen(true)}>
                <img src={GIFT} />
            </button>
        </>
    )
}
